import { render } from "./EditPropositionReponsePage.vue?vue&type=template&id=85ee6b32&ts=true"
import script from "./EditPropositionReponsePage.vue?vue&type=script&lang=ts"
export * from "./EditPropositionReponsePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__